import type { RouteObject } from 'react-router-dom'
import PageNotFound from '@/components/404'
import pagesRoutes from './pages'

const routes: Readonly<RouteObject[]> = [
  {
    path: '/',
    children: [...pagesRoutes]
  },
  {
    path: '*',
    element: <PageNotFound />
  }
]

export default routes
